import React from "react";
import CustodianCashBalanceManagement from "../../features/custodiancashbalancemanagement";
import withProviders from "../../hooks/withProviders";
import { FilterProvider, CustodianCashBalancesDefaultFilters, useFilterContext } from "../../hooks/FilterContext";
import { FiltersAppliedWarningMessage, GenericLayoutPageSubHeader, Main, PageSubHeader, ThemedIcon } from "../../components/utilities";
import { PageHeaderTop } from "../../components/layout/PageHeader";
import PageHeader from "../../components/layout/PageHeader";
import styled from "styled-components";
import { Button } from "react-bootstrap";
import { IconButton } from "../../components";
import { openCustodianCashBalanceFilters } from "../../components/modals/custodian-cash-filter";
import { MasterAccountSelect } from "../../components/forms/selects";

const HeaderTitle = styled.div`
    flex: 1;
    display: flex;
    font-size: 16px;

    & > span:not(:last-child) {
        margin-right: 1rem;
    }
`;

const CustodianCashBalancesPage = () => {

    const {
        clearFilter,
        isFiltersApplied,
        setFilter,
        filter
    } = useFilterContext();

    const onFilterButtonClicked = () => {
        openCustodianCashBalanceFilters(filter).then(
            form => {
                const { searchTerm, ...rest } = form;
                setFilter(() => ({ ...rest }));
            }
        );
    };

    return <>
        <PageHeader>
            <PageHeaderTop>
                <HeaderTitle>
                    <span>Custodian Cash Balance Management</span>
                </HeaderTitle>
            </PageHeaderTop>
        </PageHeader>
        <Main className="d-flex flex-column">
            <PageSubHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        {isFiltersApplied && <>
                            <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                            <FiltersAppliedWarningMessage className="ms-2 text-muted">
                                Warning - Filters are currently being applied to your results.
                                <br />
                                <button className="anchor" onClick={clearFilter}>Click here</button> to clear your filters.
                            </FiltersAppliedWarningMessage>
                        </>}
                    </div>
                    <div className="d-flex flex-fill justify-content-end align-items-center">
                        <MasterAccountSelect
                            className="me-2 w-50"
                            label={null}
                            placeholder="Search for a Client Account"
                            isMulti={true}
                            valueObject={filter.masterAccounts}
                            setValue={(values) => setFilter(original => {
                                return {
                                    ...original,
                                    masterAccounts: values,
                                    masterAccountIds: values.map(el => el.value)
                                }
                            })}
                        />
                        <IconButton icon={['fas', 'filter']} variant={'primary'} onClick={onFilterButtonClicked}>Filter Matches</IconButton>
                    </div>
                </div>
            </PageSubHeader>
            <section className="px-4 my-3 h-100">
                <CustodianCashBalanceManagement />
            </section>
        </Main>
    </>;
}

export default withProviders([FilterProvider, { filterStore: "cashbalances", defaultFilters: CustodianCashBalancesDefaultFilters }])(CustodianCashBalancesPage);
